import { FIELDS } from './constants';

const defaultFields = [
  {
    field: 'commands',
    title: '',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  /*{
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'sourceName',
     field: FIELDS.SOURCE_NAME,
     title: 'Source',
     label: 'Source',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Company',
     label: 'Company',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactFullName',
     field: FIELDS.CONTACT_FULL_NAME,
     title: 'Contact',
     label: 'Contact',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'vendorTypeName',
     field: FIELDS.VENDOR_TYPE_NAME,
     title: 'Vendor Type',
     label: 'Vendor Type',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'purchaseOrderId',
     field: FIELDS.PURCHASE_ORDER_ID,
     title: 'PO No',
     label: 'PO No',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'poDate',
     field: FIELDS.PODATE,
     title: 'PO Date',
     label: 'PO Date',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'partNumber',
     field: FIELDS.PART_NUMBER,
     title: 'Part Number',
     label: 'Part Number',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCode',
     field: FIELDS.DATE_CODE,
     title: 'Date Code',
     label: 'Date Code',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Received',
     label: 'Date Received',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'qtyReceived',
     field: FIELDS.QTY_RECEIVED,
     title: 'Qty Received',
     label: 'Qty Received',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'quantitySold',
     field: FIELDS.QUANTITY_SOLD,
     title: 'Qty Sold',
     label: 'Qty Sold',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'vendorPartNumber',
     field: FIELDS.VENDOR_PART_NUMBER,
     title: 'Vendor PN',
     label: 'Vendor PN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'internalPn',
     field: FIELDS.INTERNAL_PN,
     title: 'Internal PN',
     label: 'Internal PN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'nsnNumber',
     field: FIELDS.NSNNUMBER,
     title: 'NSN',
     label: 'NSN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'altNumber',
     field: FIELDS.ALT_NUMBER,
     title: 'Alternate PN',
     label: 'Alternate PN',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'sku',
     field: FIELDS.SKU,
     title: 'SKU',
     label: 'SKU',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'harmonizedCode',
     field: FIELDS.HARMONIZED_CODE,
     title: 'HTS Code',
     label: 'HTS Code',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'description',
     field: FIELDS.DESCRIPTION,
     title: 'Description',
     label: 'Description',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'poConditionName',
     field: FIELDS.POCONDITION_NAME,
     title: 'PO Condition',
     label: 'PO Condition',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'salesPersonUserFullName',
     field: FIELDS.SALES_PERSON_USER_FULL_NAME,
     title: 'Sales Person',
     label: 'Sales Person',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'manufacturerName',
     field: FIELDS.MANUFACTURER_NAME,
     title: 'Mfr',
     label: 'Mfr',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'altMfr',
     field: FIELDS.ALT_MFR,
     title: 'Alt Mfr',
     label: 'Alt Mfr',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'className',
     field: FIELDS.CLASS_NAME,
     title: 'Class',
     label: 'Class',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'categoryName',
     field: FIELDS.CATEGORY_NAME,
     title: 'Category',
     label: 'Category',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'uom',
     field: FIELDS.UOM,
     title: 'UOM',
     label: 'UOM',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'package',
     field: FIELDS.PACKAGE,
     title: 'Item Pkg',
     label: 'Item Pkg',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'piecePerPkg',
     field: FIELDS.PIECE_PER_PKG,
     title: 'SPQ',
     label: 'SPQ',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'physPkg',
     field: FIELDS.PHYS_PKG,
     title: 'Phys Pkg',
     label: 'Phys Pkg',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'leadFree',
     field: FIELDS.LEAD_FREE,
     title: 'RoHS',
     label: 'RoHS',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'tempRating',
     field: FIELDS.TEMP_RATING,
     title: 'Temp Rating',
     label: 'Temp Rating',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'partComments',
     field: FIELDS.PART_COMMENTS,
     title: 'Part Comments',
     label: 'Part Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'onHand',
     field: FIELDS.ON_HAND,
     title: 'On Hand',
     label: 'On Hand',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'inTesting',
     field: FIELDS.IN_TESTING,
     title: 'In Testing',
     label: 'In Testing',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'allocated',
     field: FIELDS.ALLOCATED,
     title: 'Allocated',
     label: 'Allocated',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'available',
     field: FIELDS.AVAILABLE,
     title: 'Available',
     label: 'Available',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'returned',
     field: FIELDS.RETURNED,
     title: 'Returned',
     label: 'Returned',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'destroyed',
     field: FIELDS.DESTROYED,
     title: 'Destroyed',
     label: 'Destroyed',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'unitCost',
     field: FIELDS.UNIT_COST,
     title: 'Unit Cost',
     label: 'Unit Cost',
     cell: 'formatAmount',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'charges',
     field: FIELDS.CHARGES,
     title: 'Charges',
     label: 'Charges',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'rack',
     field: FIELDS.RACK,
     title: 'Rack',
     label: 'Rack',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'cost',
     field: FIELDS.COST,
     title: 'Cost',
     label: 'Cost',
     cell: 'formatAmount',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'warehouseName',
     field: FIELDS.WAREHOUSE_NAME,
     title: 'Warehouse',
     label: 'Warehouse',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'location',
     field: FIELDS.LOCATION,
     title: 'Location',
     label: 'Location',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shelf',
     field: FIELDS.SHELF,
     title: 'Shelf',
     label: 'Shelf',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'bin',
     field: FIELDS.BIN,
     title: 'Bin',
     label: 'Bin',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'lotCode',
     field: FIELDS.LOT_CODE,
     title: 'Lot Code',
     label: 'Lot Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'revision',
     field: FIELDS.REVISION,
     title: 'Revision',
     label: 'Revision',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'conditionName',
     field: FIELDS.CONDITION_NAME,
     title: 'Condition',
     label: 'Condition',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'countryOfOriginName',
     field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
     title: 'COO',
     label: 'COO',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'comments',
     field: FIELDS.COMMENTS,
     title: 'Comments',
     label: 'Comments',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isQuarantined',
     field: FIELDS.IS_QUARANTINED,
     title: 'Quarantined',
     label: 'Quarantined',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateReceived',
     field: FIELDS.DATE_RECEIVED,
     title: 'Date Received',
     label: 'Date Received',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'recievedBy',
     field: FIELDS.RECIEVED_BY,
     title: 'Recieved By',
     label: 'Recieved By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'requiresInspection',
     field: FIELDS.REQUIRES_INSPECTION,
     title: 'Requires Inspection',
     label: 'Requires Inspection',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateInspected',
     field: FIELDS.DATE_INSPECTED,
     title: 'Date Inspected',
     label: 'Date Inspected',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'inspectedBy',
     field: FIELDS.INSPECTED_BY,
     title: 'Inspected By',
     label: 'Inspected By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'requiresTesting',
     field: FIELDS.REQUIRES_TESTING,
     title: 'Requires Testing',
     label: 'Requires Testing',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateTested',
     field: FIELDS.DATE_TESTED,
     title: 'Date Tested',
     label: 'Date Tested',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'testedBy',
     field: FIELDS.TESTED_BY,
     title: 'Tested By',
     label: 'Tested By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tested',
     field: FIELDS.TESTED,
     title: 'Tested',
     label: 'Tested',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'alertMessage',
     field: FIELDS.ALERT_MESSAGE,
     title: 'Alert',
     label: 'Alert',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'consigned',
     field: FIELDS.CONSIGNED,
     title: 'Consigned',
     label: 'Consigned',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'consignedToCompanyName',
     field: FIELDS.CONSIGNED_TO_COMPANY_NAME,
     title: 'Consigned For',
     label: 'Consigned For',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'consignedPercent',
     field: FIELDS.CONSIGNED_PERCENT,
     title: 'Consigned %',
     label: 'Consigned %',
     cell: 'formatPercentage',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'warrantyName',
     field: FIELDS.WARRANTY_NAME,
     title: 'Warranty',
     label: 'Warranty',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'warrantyDays',
     field: FIELDS.WARRANTY_DAYS,
     title: 'Warranty Days',
     label: 'Warranty Days',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 75,
  },{
     key: 'dateWarrantyExpires',
     field: FIELDS.DATE_WARRANTY_EXPIRES,
     title: 'Warranty Exp Date',
     label: 'Warranty Exp Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'warrantyNotes',
     field: FIELDS.WARRANTY_NOTES,
     title: 'Warranty Notes',
     label: 'Warranty Notes',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'modifiedyUserFullName',
     field: FIELDS.MODIFIEDY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isDiscrepancy',
     field: FIELDS.IS_DISCREPANCY,
     title: 'Discrepancy',
     label: 'Discrepancy',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;


export const receivedInventoryFields = [  
   {
     field: 'commands',
     title: '',
     cell: 'selectcommands',
     headerCell: 'selectCommandsHeader',
     sortable: false,
     hidden: false,
     locked: true,
     width: 40,
   },
   {
     key: 'PartNumber',
     cell: 'navigation',
     field: FIELDS.PART_NUMBER,
     title: ' Part Number',
     label: 'PartNumber',
     sortable: true,
     hidden: false,
     locked: true,
     width: 150,
   },
   {
     key: 'SourceName',
     field: FIELDS.SOURCE_NAME,
     title: ' Source Name',
     label: 'SourceName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'CompanyName',
     field: FIELDS.COMPANY_NAME,
     title: ' Company Name',
     label: 'CompanyName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'ContactFullName',
     field: FIELDS.CONTACT_FULL_NAME,
     title: ' Contact Full Name',
     label: 'ContactFullName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'PurchaseOrderId',
     field: FIELDS.PURCHASE_ORDER_ID,
     title: ' Purchase Order Id',
     label: 'PurchaseOrderId',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'PODate',
     field: FIELDS.PODATE,
     title: ' PODate',
     label: 'PODate',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'ConsignmentId',
     field: FIELDS.CONSIGNMENT_ID,
     title: ' Consignment Id',
     label: 'ConsignmentId',
     sortable: true,
     hidden: true,
     width: 150,
   },
   {
     key: 'CustomerId',
     field: FIELDS.CUSTOMER_ID,
     title: ' Customer Id',
     label: 'CustomerId',
     sortable: true,
     hidden: true,
     width: 150,
   },
   {
     key: 'CustomerName',
     field: FIELDS.CUSTOMER_NAME,
     title: ' Customer Name',
     label: 'CustomerName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'SalesPersonUserFullName',
     field: FIELDS.SALES_PERSON_USER_FULL_NAME,
     title: ' Sales Person User Full Name',
     label: 'SalesPersonUserFullName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'ShippingProviderName',
     field: FIELDS.SHIPPING_PROVIDER_NAME,
     title: ' Shipping Provider Name',
     label: 'ShippingProviderName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'ShippingMethodId',
     field: FIELDS.SHIPPING_METHOD_ID,
     title: ' Shipping Method Id',
     label: 'ShippingMethodId',
     sortable: true,
     hidden: true,
     width: 150,
   },
   {
     key: 'ShippingMethodName',
     field: FIELDS.SHIPPING_METHOD_NAME,
     title: ' Shipping Method Name',
     label: 'ShippingMethodName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'TrackingNumber',
     field: FIELDS.TRACKING_NUMBER,
     title: ' Tracking Number',
     label: 'TrackingNumber',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'SalesOrderLineId',
     field: FIELDS.SALES_ORDER_LINE_ID,
     title: ' Sales Order Line Id',
     label: 'SalesOrderLineId',
     sortable: true,
     hidden: true,
     width: 150,
   },
   {
     key: 'PurchaseOrderLineId',
     field: FIELDS.PURCHASE_ORDER_LINE_ID,
     title: ' Purchase Order Line Id',
     label: 'PurchaseOrderLineId',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'POConditionId',
     field: FIELDS.POCONDITION_ID,
     title: ' POCondition Id',
     label: 'POConditionId',
     sortable: true,
     hidden: true,
     width: 150,
   },
   {
     key: 'POConditionName',
     field: FIELDS.POCONDITION_NAME,
     title: ' POCondition Name',
     label: 'POConditionName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'QuantitySold',
     field: FIELDS.QUANTITY_SOLD,
     title: ' Quantity Sold',
     label: 'QuantitySold',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'PartId',
     field: FIELDS.PART_ID,
     title: ' Part Id',
     label: 'PartId',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'VendorPartNumber',
     field: FIELDS.VENDOR_PART_NUMBER,
     title: ' Vendor Part Number',
     label: 'VendorPartNumber',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'InternalPN',
     field: FIELDS.INTERNAL_PN,
     title: ' Internal PN',
     label: 'InternalPN',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'NSNNumber',
     field: FIELDS.NSNNUMBER,
     title: ' NSNNumber',
     label: 'NSNNumber',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'AltNumber',
     field: FIELDS.ALT_NUMBER,
     title: ' Alt Number',
     label: 'AltNumber',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'SKU',
     field: FIELDS.SKU,
     title: ' SKU',
     label: 'SKU',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'HarmonizedCode',
     field: FIELDS.HARMONIZED_CODE,
     title: ' Harmonized Code',
     label: 'HarmonizedCode',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Description',
     field: FIELDS.DESCRIPTION,
     title: ' Description',
     label: 'Description',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'ManufacturerName',
     field: FIELDS.MANUFACTURER_NAME,
     title: ' Manufacturer Name',
     label: 'ManufacturerName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'AltMfr',
     field: FIELDS.ALT_MFR,
     title: ' Alt Mfr',
     label: 'AltMfr',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'ClassName',
     field: FIELDS.CLASS_NAME,
     title: ' Class Name',
     label: 'ClassName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'CategoryName',
     field: FIELDS.CATEGORY_NAME,
     title: ' Category Name',
     label: 'CategoryName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'UOM',
     field: FIELDS.UOM,
     title: ' UOM',
     label: 'UOM',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Package',
     field: FIELDS.PACKAGE,
     title: ' Package',
     label: 'Package',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'PiecePerPkg',
     field: FIELDS.PIECE_PER_PKG,
     title: ' Piece Per Pkg',
     label: 'PiecePerPkg',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'PhysPkg',
     field: FIELDS.PHYS_PKG,
     title: ' Phys Pkg',
     label: 'PhysPkg',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'LeadFree',
     field: FIELDS.LEAD_FREE,
     title: ' Lead Free',
     label: 'LeadFree',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'TempRating',
     field: FIELDS.TEMP_RATING,
     title: ' Temp Rating',
     label: 'TempRating',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'PartComments',
     field: FIELDS.PART_COMMENTS,
     title: ' Part Comments',
     label: 'PartComments',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'QtyReceived',
     field: FIELDS.QTY_RECEIVED,
     title: ' Qty Received',
     label: 'QtyReceived',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'OnHand',
     field: FIELDS.ON_HAND,
     title: ' Quantity Received',
     label: 'OnHand',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Allocated',
     field: FIELDS.ALLOCATED,
     title: ' Allocated',
     label: 'Allocated',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'InTesting',
     field: FIELDS.IN_TESTING,
     title: ' In Testing',
     label: 'InTesting',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Available',
     field: FIELDS.AVAILABLE,
     title: ' Available',
     label: 'Available',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Returned',
     field: FIELDS.RETURNED,
     title: ' Returned',
     label: 'Returned',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Destroyed',
     field: FIELDS.DESTROYED,
     title: ' Destroyed',
     label: 'Destroyed',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'UnitCost',
     field: FIELDS.UNIT_COST,
     title: ' Unit Cost',
     label: 'UnitCost',
     cell: 'formatAmount',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Charges',
     field: FIELDS.CHARGES,
     title: ' Charges',
     label: 'Charges',
     cell: 'formatAmount',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Cost',
     field: FIELDS.COST,
     title: ' Cost',
     label: 'Cost',
     cell: 'formatAmount',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'WarehouseName',
     field: FIELDS.WAREHOUSE_NAME,
     title: ' Warehouse Name',
     label: 'WarehouseName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Location',
     field: FIELDS.LOCATION,
     title: ' Location',
     label: 'Location',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Rack',
     field: FIELDS.RACK,
     title: ' Rack',
     label: 'Rack',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Shelf',
     field: FIELDS.SHELF,
     title: ' Shelf',
     label: 'Shelf',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Bin',
     field: FIELDS.BIN,
     title: ' Bin',
     label: 'Bin',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'DateCode',
     field: FIELDS.DATE_CODE,
     title: ' Date Code',
     label: 'DateCode',
     cell: 'dynamicNavigation',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'LotCode',
     field: FIELDS.LOT_CODE,
     title: ' Lot Code',
     label: 'LotCode',
     cell: 'dynamicNavigation',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Revision',
     field: FIELDS.REVISION,
     title: ' Revision',
     label: 'Revision',
     cell: 'dynamicNavigation',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'ConditionName',
     field: FIELDS.CONDITION_NAME,
     title: ' Condition Name',
     label: 'ConditionName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'CountryOfOriginName',
     field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
     title: ' Country Of Origin Name',
     label: 'CountryOfOriginName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Comments',
     field: FIELDS.COMMENTS,
     title: ' Comments',
     label: 'Comments',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'IsQuarantined',
     field: FIELDS.IS_QUARANTINED,
     title: ' Is Quarantined',
     label: 'IsQuarantined',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'DateReceived',
     field: FIELDS.DATE_RECEIVED,
     title: ' Date Received',
     label: 'DateReceived',
     cell: 'formatDate',
     sortable: true,    
     hidden: false,
     width: 150,
   },
   {
     key: 'RecievedBy',
     field: FIELDS.RECIEVED_BY,
     title: ' Recieved By',
     label: 'RecievedBy',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'RequiresInspection',
     field: FIELDS.REQUIRES_INSPECTION,
     title: ' Requires Inspection',
     label: 'RequiresInspection',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'DateInspected',
     field: FIELDS.DATE_INSPECTED,
     title: ' Date Inspected',
     label: 'DateInspected',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'InspectedBy',
     field: FIELDS.INSPECTED_BY,
     title: ' Inspected By',
     label: 'InspectedBy',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'RequiresTesting',
     field: FIELDS.REQUIRES_TESTING,
     title: ' Requires Testing',
     label: 'RequiresTesting',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'DateTested',
     cell: 'formatDate',
     field: FIELDS.DATE_TESTED,
     title: ' Date Tested',
     label: 'DateTested',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'TestedBy',
     field: FIELDS.TESTED_BY,
     title: ' Tested By',
     label: 'TestedBy',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Tested',
     field: FIELDS.TESTED,
     title: ' Tested',
     label: 'Tested',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'AlertMessage',
     field: FIELDS.ALERT_MESSAGE,
     title: ' Alert Message',
     label: 'AlertMessage',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Consigned',
     field: FIELDS.CONSIGNED,
     title: ' Consigned',
     label: 'Consigned',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'ConsignedToCompanyName',
     field: FIELDS.CONSIGNED_TO_COMPANY_NAME,
     title: ' Consigned To Company Name',
     label: 'ConsignedToCompanyName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'ConsignedPercent',
     field: FIELDS.CONSIGNED_PERCENT,
     title: ' Consigned Percent',
     label: 'ConsignedPercent',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'WarrantyName',
     field: FIELDS.WARRANTY_NAME,
     title: ' Warranty Name',
     label: 'WarrantyName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'WarrantyDays',
     field: FIELDS.WARRANTY_DAYS,
     title: ' Warranty Days',
     label: 'WarrantyDays',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'DateWarrantyExpires',
     cell: 'formatDate',
     field: FIELDS.DATE_WARRANTY_EXPIRES,
     title: ' Date Warranty Expires',
     label: 'DateWarrantyExpires',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'WarrantyNotes',
     field: FIELDS.WARRANTY_NOTES,
     title: ' Warranty Notes',
     label: 'WarrantyNotes',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'IsSplit',
     field: FIELDS.IS_SPLIT,
     title: ' Is Split',
     label: 'IsSplit',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'DateCreated',
     cell: 'formatDate',
     field: FIELDS.DATE_CREATED,
     title: ' Date Created',
     label: 'DateCreated',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'DateModified',
     cell: 'formatDate',
     field: FIELDS.DATE_MODIFIED,
     title: ' Date Modified',
     label: 'DateModified',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'CreatedByUserId',
     field: FIELDS.CREATED_BY_USER_ID,
     title: ' Created By User Id',
     label: 'CreatedByUserId',
     sortable: true,
     hidden: true,
     width: 150,
   },
   {
     key: 'CreatedByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: ' Created By User Full Name',
     label: 'CreatedByUserFullName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'ModifiedByUserId',
     field: FIELDS.MODIFIED_BY_USER_ID,
     title: ' Modified By User Id',
     label: 'ModifiedByUserId',
     sortable: true,
     hidden: true,
     width: 150,
   },
   {
     key: 'ModifiedyUserFullName',
     field: FIELDS.MODIFIEDY_USER_FULL_NAME,
     title: ' Modifiedy User Full Name',
     label: 'ModifiedyUserFullName',
     sortable: true,
     hidden: false,
     width: 150,
   },
   {
     key: 'Active',
     field: FIELDS.ACTIVE,
     title: ' Active',
     label: 'Active',
     sortable: true,
     hidden: false,
     width: 150,
   },
   
   // {
   //   field: 'detailcommands',
   //   title: '',
   //   cell: 'detailcommands',
   //   headerCell: 'detailCommandsHeader',
   //   sortable: false,
   //   hidden: false,
   //   locked: true,
   //   width: 30,
   // },
   {
     field: 'deletecommands',
     title: '',
     cell: 'deletecommands',
     headerCell: 'commandsHeader',
     sortable: false,
     hidden: false,
     locked: true,
     width: 30,
   },
 ];
